import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpEvent,
  HttpHeaders,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {DocumentTypes} from "../_models/document-type";

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root',
})
export class FileStorageService {
  private FIlESTORAGE_API: string;
  constructor(private http: HttpClient) {
    this.FIlESTORAGE_API = `${environment.apiUrl}/file`;
  }

  uploadProfilePhoto(file: File): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();

    formData.append('file', file);

    const req = new HttpRequest(
      'POST',
      `${this.FIlESTORAGE_API}/uploadprofile`,
      formData,
      {
        reportProgress: true,
        responseType: 'json',
      }
    );

    return this.http.request(req);
  }

  uploadCertificationDocument(
    file: File,
    certificationId: number,
    documentType: DocumentTypes
  ): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('certificationId', certificationId + '');
    formData.append('documentType', documentType);
    const req = new HttpRequest(
      'POST',
      `${this.FIlESTORAGE_API}/upload-cert`,
      formData,
      {
        reportProgress: true,
        responseType: 'json',
      }
    );
    return this.http.request(req);
  }

  async downloadProfilePhoto(): Promise<any> {
    return await this.http.get(`${this.FIlESTORAGE_API}/download/profile_picture`, {
      responseType: 'blob',
    }).toPromise();
  }

  downloadUserProfilePhoto(userId: number): Observable<any> {
    return this.http.get(
      `${this.FIlESTORAGE_API}/download/profile_picture/${userId}`,
      {
        responseType: 'blob',
      }
    );
  }

  async listCertificationDocuments(): Promise<any> {
    return await this.http.get(`${this.FIlESTORAGE_API}/list/certification_documents`).toPromise();
  }

  listCertificationDocumentsForCertification(
    certificationId: number
  ): Observable<any> {
    return this.http.get(
      `${this.FIlESTORAGE_API}/list/certification_documents/${certificationId}`
    );
  }

  getCertificationDocumentUrl(documentId: number, fileName: string) {
    this.http.get(`${this.FIlESTORAGE_API}/download/certification_document/${documentId}`,
        {responseType: 'blob', observe: 'response'}).subscribe(r => {
      const blob = new Blob([r.body!], { type: r.headers.get('Content-Type') || 'application/octet-stream' });
      const a = document.createElement('a');
      const objectUrl = URL.createObjectURL(blob);
      a.href = objectUrl;
      a.download = fileName;  // Set the file name
      document.body.appendChild(a);
      a.click();

      // Clean up
      document.body.removeChild(a);
      URL.revokeObjectURL(objectUrl);
    })
  }

  getAdminCertificationDocumentUrl(documentId: number, fileName: string, userId: number) {
    this.http.get(`${this.FIlESTORAGE_API}/download/admin-certification_document/${documentId}/${userId}`,
        {responseType: 'blob', observe: 'response'}).subscribe(r => {
      const blob = new Blob([r.body!], { type: r.headers.get('Content-Type') || 'application/octet-stream' });
      const a = document.createElement('a');
      const objectUrl = URL.createObjectURL(blob);
      a.href = objectUrl;
      a.download = fileName;  // Set the file name
      document.body.appendChild(a);
      a.click();

      // Clean up
      document.body.removeChild(a);
      URL.revokeObjectURL(objectUrl);
    })
  }

  getAttachmentUrl(attachmentId: number, fileName: string) {
    this.http.get(`${this.FIlESTORAGE_API}/download/attachment_wallet_support/${attachmentId}`,
        {responseType: 'blob', observe: 'response'}).subscribe(r => {
      const blob = new Blob([r.body!], { type: r.headers.get('Content-Type') || 'application/octet-stream' });
      const a = document.createElement('a');
      const objectUrl = URL.createObjectURL(blob);
      a.href = objectUrl;
      a.download = fileName;  // Set the file name
      document.body.appendChild(a);
      a.click();

      // Clean up
      document.body.removeChild(a);
      URL.revokeObjectURL(objectUrl);
    })
  }

  getAttachmentUrlFromAdmin(attachmentId: number, fileName: string) {
    this.http.get(`${this.FIlESTORAGE_API}/download/attachment_wallet_support_from_admin/${attachmentId}`,
        {responseType: 'blob', observe: 'response'}).subscribe(r => {
      const blob = new Blob([r.body!], { type: r.headers.get('Content-Type') || 'application/octet-stream' });
      const a = document.createElement('a');
      const objectUrl = URL.createObjectURL(blob);
      a.href = objectUrl;
      a.download = fileName;  // Set the file name
      document.body.appendChild(a);
      a.click();

      // Clean up
      document.body.removeChild(a);
      URL.revokeObjectURL(objectUrl);
    })
  }

  getAttachmentUrlAdmin(attachmentId: number, fileName: string) {
    this.http.get(`${this.FIlESTORAGE_API}/download/attachment_wallet_support_admin/${attachmentId}`,
        {responseType: 'blob', observe: 'response'}).subscribe(r => {
          const blob = new Blob([r.body!], { type: r.headers.get('Content-Type') || 'application/octet-stream' });
          const a = document.createElement('a');
          const objectUrl = URL.createObjectURL(blob);
          a.href = objectUrl;
          a.download = fileName;  // Set the file name
          document.body.appendChild(a);
          a.click();

          // Clean up
          document.body.removeChild(a);
          URL.revokeObjectURL(objectUrl);
    })
  }

  async deleteCertificationDocument(documentId: number): Promise<any> {
    return await this.http.post(`${this.FIlESTORAGE_API}/delete/certification-document`, {documentId: documentId}).toPromise();
  }

  async deleteAdminCertificationDocument(documentId: number, userId: number): Promise<any> {
    return await this.http.post(`${this.FIlESTORAGE_API}/delete/admin-certification-document`, {documentId: documentId, userId: userId}).toPromise();
  }
}
